import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { CapsuleButton, GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import {
  BasicInfo,
  Title,
  SubTitle,
  ComponentDivider,
  ContentWrapper,
  Underlinelink,
  Guildelines,
  CompleteIcon,
  CompleteMessage,
  ContentMessage,
  ViewEditRemove,
  RemoveWrapper,
  CapsuleButtonWrapper
} from "./styles";
import {
  DisplayFlexSpaceMobile
} from "../InvestmentOptions/styles";
import {
  CollapseWrap,
  Content,
  AccordionBorder,
  SaveAndContinueButton
} from "../../styles";
import { connect } from "react-redux";
import {
  initializeValues,
  removeContributionType,
  updateContributionStatusJson,
  step1Edit,
  updateClearStatus, showErrorMessages
} from "../../actions";
import { Rules } from "../CommonComponents/Rules/Rules";
import history from "../../../../../../history/history";
import AssetHeldAtVanguard from "./Components/AssetHeldAtVanguard";
import AssetHeldOutsideVanguard from "./Components/AssetHeldOutsideVanguard";
import CheckorEBT from "./Components/CheckorEBT";
import Wire from "./Components/Wire";
import StockCertificate from "./Components/StockCertificate";
import {
  defaultMutualFundAHAV,
  defaultSecurityGiftAHAV,
  defaultMutualFundAHOV,
  defaultSecurityGiftAHOV,
  defaultCheck,
  defaultStock,
  defaultAllocation
} from "../CommonComponents/Data";
import LearnMore from "../CommonComponents/LearnMore/LearnMore";
import completeTick from "../../../../../../assets/icons/confirmation-tick.svg";
import replaceNonDigit from "../../../../../../utils/replaceNonDigit";
import { initiateTracking, recordError } from "../../../../../../utils/commonUtil";
import inCompleteTick from "../../../../../../assets/icons/Incompleteicon.svg";
import incompleteError from "../../../../../../assets/icons/incompleteError.svg";
import { DisplayFlex } from "../../../../../../CommonComponents/commonStyles";
import Popup from "./Components/Popup/Popup";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import { contributionTypeState } from "../../selectors";

let aVG = "none",
  aOVG = "none",
  check = "none",
  wire = "none",
  stock = "none",
  popUpState = false,
  selectedIndex = -1;
let learnMorePopUp = false;
let contributionStatus = {
  assetHeldatVG: null,
  assetOutsideVG: null,
  checkOrEBT: null,
  wire: null,
  stockCertificate: null
};
let isNextEnabled = false;
let softWarningPopUp = false;
let tickerWarningPopUp = false;
let isRemoveClicked = null;
let isCancelClicked = false;

export class ContributionType extends React.Component {
  constructor(props) {
    super(props);
    this.state = { update: true, show: false, popupInfo: {}, theposition: 0, dummyUpdate: false, isOneSelected: true, isNextClicked: false };
    this.handleNext = this.handleNext.bind(this);
    this.showContent = this.showContent.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);
    contributionStatus = this.props.contributionStatus
      ? Object.assign({}, this.props.contributionStatus)
      : {
          assetHeldatVG: null,
          assetOutsideVG: null,
          checkOrEBT: null,
          wire: null,
          stockCertificate: null
        };
  }

  componentDidMount() {
    if (
      history.location.state &&
      history.location.state.advisorType === "step1Edit"
    ) {
      this.props.step1Edit({ step: 1, edit: true });
      window.scrollTo(0, 0);
    }
    aVG = "none";
    aOVG = "none";
    check = "none";
    wire = "none";
    stock = "none";
    isNextEnabled = this.enableNextButton();
  }

  componentWillMount() {
    if (
      history.location.state &&
      history.location.state.source &&
      history.location.state.source === "header"
    ) {
    }
  }

  showContent = index => {
    try {
      isNextEnabled = this.enableNextButton();
      if (index === 0) {
        let newState = "";
        aVG === "block" ? (newState = "none") : (newState = "block");
        aVG = newState;
        this.scrollPage("assetHeldAtVGid", "assetHeldatVG");
        this.setState({ update: !this.state.update });
        if(aVG === 'none'){
          if(contributionStatus["assetHeldatVG"] === false){
            this.setState({isOneSelected: true});
          }
        } else if(aVG === 'block' && contributionStatus["assetHeldatVG"] !== null){
          this.props.showErrorMessages('assetHeldatVG');
        }
        if(contributionStatus["assetHeldatVG"]) this.changeAccordionBorder('assetHeldAtVGAccId', 0);
        this.accordionAnalytics('Step 1 Select Contribution Type - Asset held at Vanguard',aVG, contributionStatus["assetHeldatVG"]);
      } else if (index === 1) {
        let newState = "";
        this.scrollPage("assetOutVGid", "assetOutsideVG");
        aOVG === "block" ? (newState = "none") : (newState = "block");
        aOVG = newState;
        this.setState({ update: !this.state.update });
        if(aOVG === 'none'){
          if(contributionStatus["assetOutsideVG"] === false){ 
            this.setState({isOneSelected: true});
          }
        } else if(aOVG === 'block' && contributionStatus["assetOutsideVG"] !== null){
          this.props.showErrorMessages('assetOutsideVG');
        }
        if(contributionStatus["assetOutsideVG"]) this.changeAccordionBorder('assetOutVGAccId', 0);
        this.accordionAnalytics('Step 1 Select Contribution Type - Asset held outside Vanguard',aOVG, contributionStatus["assetOutsideVG"]);
      } else if (index === 2) {
        let newState = "";
        check === "block" ? (newState = "none") : (newState = "block");
        check = newState;
        this.scrollPage("checkid", "checkOrEBT");
        this.setState({ update: !this.state.update });
        if(check === 'none'){
          if(contributionStatus["checkOrEBT"] === false){ 
            this.setState({isOneSelected: true});
          }
        } else if(check === 'block' && contributionStatus["checkOrEBT"] !== null){
          this.props.showErrorMessages('checkOrEBT');
        }
        if(contributionStatus["checkOrEBT"]) this.changeAccordionBorder('checkAccId', 0);
        this.accordionAnalytics('Step 1 Select Contribution Type - Check or electronic bank transfer',check, contributionStatus["checkOrEBT"]);
      } else if (index === 3) {
        let newState = "";
        wire === "block" ? (newState = "none") : (newState = "block");
        wire = newState;
        this.scrollPage("wireid", "wire");
        this.setState({ update: !this.state.update });
        if(wire === 'none'){
          if(contributionStatus["wire"] === false){
           this.setState({isOneSelected: true});
          }
        } else if(wire === 'block' && contributionStatus["wire"] !== null){
          this.props.showErrorMessages('wire');
        }
        if(contributionStatus["wire"]) this.changeAccordionBorder('wireAccId', 0);
        this.accordionAnalytics('Step 1 Select Contribution Type - Wire',wire, contributionStatus["wire"]);
      } else if (index === 4) {
        let newState = "";
        stock === "block" ? (newState = "none") : (newState = "block");
        stock = newState;
        this.scrollPage("stockCertid", "stockCertificate");
        this.setState({ update: !this.state.update });
        if(stock === 'none'){
          if(contributionStatus["stockCertificate"] === false){ 
            this.setState({isOneSelected: true});
          }
        } else if(stock === 'block' && contributionStatus["stockCertificate"] !== null){
          this.props.showErrorMessages('stockCertificate');
        }
        if(contributionStatus["stockCertificate"]) this.changeAccordionBorder('stockAccId', 0);
        this.accordionAnalytics('Step 1 Select Contribution Type - Stock Certificate',stock, contributionStatus["stockCertificate"]);
      }
    } catch (error) {
      recordError(error);
    }
  };

  hasOneSelectedContribution = status => {
    let contributionSelected = false;
    Object.keys(status).map(type => {
      contributionSelected = contributionSelected || status[type];
      return contributionSelected;
    })
    this.setState({isOneSelected: contributionSelected});
  }

  scrollPage(id, status) {
    const elmnt = document.getElementById(id);
    if (elmnt) elmnt.scrollIntoView(true);
    window.scrollBy(0, -250);
  }

  clearAll = index => {
    let status = this.props.contributionStatus;
    let contribTypes = this.props.contributionDetails;
    let isMF = false;
    let isSG = false;
    if (selectedIndex === 0) {
      isMF = contribTypes.assetHeldatVG.mfSelected;
      isSG = contribTypes.assetHeldatVG.sgSelected;
      status["assetHeldatVG"] = null;
      const elmnt = document.getElementById('assetHeldAccessId');
      elmnt.nextElementSibling.style.borderColor = '#b6bdbd';
      this.scrollPage("assetHeldAtVGid", "assetHeldatVG");
    } else if (selectedIndex === 1) {
      isMF = contribTypes.assetOutsideVG.mfSelected;
      isSG = contribTypes.assetOutsideVG.sgSelected;
      status["assetOutsideVG"] = null;
      this.scrollPage("assetOutVGid", "assetOutsideVG");
    } else if (selectedIndex === 2) {
      isMF = contribTypes.checkOrEBT.checkSelected;
      status["checkOrEBT"] = null;
      this.scrollPage("checkid", "checkOrEBT");
    } else if (selectedIndex === 3) {
      isMF = contribTypes.wire.wireSelected;
      this.scrollPage("wireid", "wire");
      status["wire"] = null;
    } else if (selectedIndex === 4) {
      isMF = contribTypes.stockCertificate.stockSelected;
      this.scrollPage("stockCertid", "stockCertificate");
      status["stockCertificate"] = null;
    }
    contributionStatus = status;
    this.setState({ update: !this.state.update });
    this.props.removeContributionType(selectedIndex, "clear");
    this.forceUpdate();
    popUpState = false;
  };

  onRemoveClick = index => {
    this.props.removeContributionType(selectedIndex, "remove");
    let status = this.props.contributionStatus;
    let typeRemoved = '';
    if (selectedIndex === 0) {
      this.scrollPage("assetHeldAtVGid", "assetHeldatVG");
      status["assetHeldatVG"] = null;
      const elmnt = document.getElementById('assetHeldAccessId');
      elmnt.nextElementSibling.style.borderColor = '#b6bdbd';
      typeRemoved = 'assetHeldatVG';
      this.removeAccordionAnalytics('Step 1 Select Contribution Type - Asset held at Vanguard');
    } else if (selectedIndex === 1) {
      this.scrollPage("assetOutVGid", "assetOutsideVG");
      status["assetOutsideVG"] = null;
      typeRemoved = 'assetOutsideVG';     
       this.removeAccordionAnalytics('Step 1 Select Contribution Type - Asset held outside Vanguard');
    } else if (selectedIndex === 2) {
      this.scrollPage("checkid", "checkOrEBT");
      status["checkOrEBT"] = null;
      typeRemoved = 'checkOrEBT';
      this.removeAccordionAnalytics('Step 1 Select Contribution Type - Check or electronic bank transfer');
    } else if (selectedIndex === 3) {
      this.scrollPage("wireid", "wire");
      status["wire"] = null;
      typeRemoved = 'wire';
      this.removeAccordionAnalytics('Step 1 Select Contribution Type - Wire');
    } else if (selectedIndex === 4) {
      this.scrollPage("stockCertid", "stockCertificate");
      status["stockCertificate"] = null;
      typeRemoved = 'stockCertificate';
      this.removeAccordionAnalytics('Step 1 Select Contribution Type - Stock Certificate');
    }
    contributionStatus = status;
    this.hasOneSelectedContribution(status);
    isNextEnabled = this.enableNextButton(typeRemoved);
    this.setState({
      show: false
    })
    this.props.updateContributionStatusJson(status);
    popUpState = false;
  };

  closeModal = () => {
    popUpState = false;
    softWarningPopUp = false;
    isRemoveClicked = null;
    this.setState({
      show: false
    });
  };

  closeTickerModal = () => {
    popUpState = false;
    softWarningPopUp = false;
    tickerWarningPopUp = null;
    this.setState({
      show: false
    });
  };

  removePopupContent = this.props.alertData && this.props.alertData.remove && this.props.alertData.remove.length ? 
  {
    heading: this.props.alertData.remove[0].field_header,
    line1: this.props.alertData.remove[0].field_description,
    line2: '',
    continue: this.props.alertData.remove[0].field_alert_button1_text,
    cancel: this.props.alertData.remove[0].field_alert_button2_text,
    type: "removeInfo"
  } : {
    heading: "Remove Information",
    line1: "Are you sure you want to remove information?",
    line2: "Do you want to continue?",
    continue: "continue",
    cancel: "No, take me back",
    type: "removeInfo"
  };

  clearAllPopupContent = this.props.alertData && this.props.alertData.clearAll && this.props.alertData.clearAll.length ? 
  {
    heading: this.props.alertData.clearAll[0].field_header,
    line1: this.props.alertData.clearAll[0].field_description,
    line2: '',
    continue: this.props.alertData.clearAll[0].field_alert_button1_text,
    cancel: this.props.alertData.clearAll[0].field_alert_button2_text,
    type: "removeInfo"
  } : {
    heading: "Clear All",
    line1: "This will clear all values entered so far.",
    line2: "Do you want to continue?",
    continue: "continue",
    cancel: "No, take me back",
    type: "removeInfo"
  };

  tickerPopupContent =  {
    heading: "Fund Information",
    line1: "It appears the ticker symbol you entered is not in our system. First, please check that you have entered the correct ticker symbol. If it has been entered correctly, it may be new to our system. We will reach out to you if we require any additional information to complete your transaction.",
    line2: "",
    continue: "continue",
    cancel: "No, take me back",
    type: "removeInfo"
  };

  showPopUp = index => {
    try {
      selectedIndex = index;
      popUpState = true;
      isRemoveClicked = true;
      this.setState({ show: true });
    } catch (error) {
      recordError(error);
    }
  };

  showClearAllPopUp = index => {
    try {
      selectedIndex = index;
      popUpState = true;
      isRemoveClicked = false;
      this.setState({ show: true });
    } catch (error) {
      recordError(error);
    }
  };

  handleOkay = () => {
    document.body.style.overflow = "";
    learnMorePopUp = false;
    this.setState({
      show: false
    });
  };

  showLearnMore = (name, description) => {
    try {
      let data = { name: name, description: description };
      this.setState({ popupInfo: data });
      learnMorePopUp = true;
      this.setState({ show: true });
    } catch (error) {
      recordError(error);
    }
  };

  markup = value => {
    return { __html: value };
  };

  createAccordionData = config => {
      const currentStatus = JSON.parse(JSON.stringify(contributionStatus));
      const statusValue = this.props.contributionStatus ? JSON.parse(JSON.stringify(this.props.contributionStatus)) : [];
      contributionStatus = this.props.contributionStatus
          ? Object.assign({}, this.props.contributionStatus)
       : {
              assetHeldatVG: null,
              assetOutsideVG: null,
              checkOrEBT: null,
              wire: null,
              stockCertificate: null
            };
      if(this.props.contributionStatus){
      contributionStatus = {
        assetHeldatVG: aVG === 'none' ? currentStatus['assetHeldatVG'] : statusValue['assetHeldatVG'] ,
        assetOutsideVG: aOVG === 'none' ? currentStatus['assetOutsideVG'] : statusValue['assetOutsideVG'],
        checkOrEBT: check === 'none' ? currentStatus['checkOrEBT'] : statusValue['checkOrEBT'],
        wire: wire === 'none' ? currentStatus['wire'] : statusValue['wire'],
        stockCertificate: stock === 'none' ? currentStatus['stockCertificate'] : statusValue['stockCertificate']
      }
    }
    return (
      <CollapseWrap>
        {popUpState === true ? (
          <Popup
            id='poup-mdl1'
            width="481px"
            mwidth="88%"
            content={
              isRemoveClicked
                ? this.removePopupContent
                : this.clearAllPopupContent
            }
            closeModal={this.closeModal}
            handleRemove={
              isRemoveClicked
                ? () => this.onRemoveClick()
                : () => this.clearAll()
            }
          />
        ) : null}
        {learnMorePopUp === true ? (
          <LearnMore
            id='learn-more-popup'
            handleOkay={this.handleOkay}
            popUpInfo={this.state.popupInfo}
          />
        ) : null}
        <AccordionBorder id="assetHeldAtVGAccId">
          <ContentWrapper id="assetHeldAtVGid">
            <SubTitle>{config[0].Name}</SubTitle>
            {contributionStatus["assetHeldatVG"] === null ? (
              <>
                <Content id='content1'>
                  <div
                    dangerouslySetInnerHTML={this.markup(config[0].Description)}
                  ></div>
                  <Guildelines
                    data-test='guide-lines1'
                    onClick={() =>
                      this.showLearnMore(
                        config[0].Name,
                        config[0].learnMoreDescription
                      )
                    }
                    id="anrLearnMoreAsset"
                  >
                    Learn More
                  </Guildelines>
                </Content>
              </>
            ) : aVG === "none" ? (
              <ContentMessage justify="space-between" align="center">
                <Content>
                  <div
                    dangerouslySetInnerHTML={this.markup(config[0].Description)}
                  ></div>
                  <Guildelines
                    onClick={() =>
                      this.showLearnMore(
                        config[0].Name,
                        config[0].learnMoreDescription
                      )
                    }
                    id="anrLearnMore"
                  >
                    Learn More
                  </Guildelines>
                </Content>
                <ContentMessage marginBottom="10px" align="flex-start" mbFlexDirection="unset">
                  <CompleteIcon
                    status={contributionStatus["assetHeldatVG"]}
                    src={
                      contributionStatus["assetHeldatVG"] === true
                        ? completeTick
                        : contributionStatus["assetHeldatVG"] === false
                        ? (this.state.isNextClicked ? incompleteError : inCompleteTick)
                        : null
                    }
                    alt={contributionStatus["assetHeldatVG"] ? 'complete' : 'inComplete'}
                  />
                  <CompleteMessage status={contributionStatus["assetHeldatVG"]} className={this.state.isNextClicked ? 'error' : ''}>
                    { contributionStatus["assetHeldatVG"] === false
                      ? "Incomplete"
                      : null}
                  </CompleteMessage>
                </ContentMessage>
              </ContentMessage>
            ) : (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[0].Description)}
                ></div>
                <Guildelines
                  data-test='guide-line2'
                  onClick={() =>
                    this.showLearnMore(
                      config[0].Name,
                      config[0].learnMoreDescription
                    )
                  }
                  id="anrLearnMoreNonAsset"
                >
                  Learn More
                </Guildelines>
              </Content>
            )}
            <ViewEditRemove>
              <div className={aVG === "none" ? "block" : "display-none"}>
                <CapsuleButton 
                    text = {contributionStatus["assetHeldatVG"] === null
                    ? "Select"
                    : "View and Edit"}
                    padding = {contributionStatus["assetHeldatVG"] === null
                    ? "5px 35px" : '7px 35px'}
                    height = {contributionStatus["assetHeldatVG"] === null
                    ? 'auto' : null}
                    onClick={index => {
                      this.showContent((index = 0));
                    }}
                    id="btnSelViewEdit"
                    whiteBackground = {true}
                   />
              </div>
              <div
                className={
                  contributionStatus["assetHeldatVG"] !== null && aVG === "none"
                    ? "block"
                    : "display-none"
                }
              >
                <RemoveWrapper>
                  <Underlinelink data-test='remove-link1'onClick={() => this.showPopUp(0)} id="anrRemoveAssetHeld">
                    Remove
                  </Underlinelink>
                </RemoveWrapper>
              </div>
            </ViewEditRemove>
            <div className={aVG === "block" ? "block" : "display-none"}>
              <AssetHeldAtVanguard
                status={contributionStatus["assetHeldatVG"]}
              />
            </div>
            <div className={aVG === "block" ? "block" : "display-none"}>
              {contributionStatus["assetHeldatVG"] === null ? (
                <CapsuleButton
                  text= "Show Less"
                  whiteBackground={true}
                  onClick={index => {
                    this.showContent((index = 0));
                  }}
                  id="btnShowLess"
                />
              ) : (
                <ViewEditRemove>
                  <SaveAndContinueButton
                    primary
                    width="170px"
                    height="30px"
                    onClick={index => {
                      this.showContent((index = 0));
                    }}
                    id="btnSaveContinue"
                  >
                    Save to continue
                  </SaveAndContinueButton>
                  <RemoveWrapper>
                    <Underlinelink id="anrClearAll" onClick={() => this.showClearAllPopUp(0)}>
                      Clear All
                    </Underlinelink>
                  </RemoveWrapper>
                </ViewEditRemove>
              )}
            </div>
          </ContentWrapper>
        </AccordionBorder>
        <AccordionBorder id="assetOutVGAccId">
          <ContentWrapper id="assetOutVGid">
            <SubTitle>{config[1].Name}</SubTitle>
            {contributionStatus["assetOutsideVG"] === null ? (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[1].Description)}
                ></div>
                <Guildelines
                  data-test='gudie-lines2'
                  onClick={() =>
                    this.showLearnMore(
                      config[1].Name,
                      config[1].learnMoreDescription
                    )
                  }
                  id="anrLearnAssetOut"
                >
                  Learn More
                </Guildelines>
              </Content>
            ) : aOVG === "none" ? (
              <ContentMessage justify="space-between" align="center">
                <Content>
                  <div
                    dangerouslySetInnerHTML={this.markup(config[1].Description)}
                  ></div>
                  <Guildelines
                    onClick={() =>
                      this.showLearnMore(
                        config[1].Name,
                        config[1].learnMoreDescription
                      )
                    }
                    id="anrLearnOVG"
                  >
                    Learn More
                  </Guildelines>
                </Content>
                <ContentMessage marginBottom="10px" align="flex-start" mbFlexDirection="unset">
                  <CompleteIcon
                    status={contributionStatus["assetOutsideVG"]}
                    src={
                      contributionStatus["assetOutsideVG"] === true
                        ? completeTick
                        : contributionStatus["assetOutsideVG"] === false
                        ? (this.state.isNextClicked ? incompleteError : inCompleteTick)
                        : null
                    }
                    alt={contributionStatus["assetOutsideVG"] ? 'complete' : 'inComplete'}
                  />
                  <CompleteMessage status={contributionStatus["assetOutsideVG"]} className={this.state.isNextClicked ? 'error' : ''}>
                    { contributionStatus["assetOutsideVG"] === false
                      ? "Incomplete"
                      : null}
                  </CompleteMessage>
                </ContentMessage>
              </ContentMessage>
            ) : (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[1].Description)}
                ></div>
                <Guildelines
                  onClick={() =>
                    this.showLearnMore(
                      config[1].Name,
                      config[1].learnMoreDescription
                    )
                  }
                  id="anrLearnm"
                >
                  Learn More
                </Guildelines>
              </Content>
            )}
            <ViewEditRemove>
              <div className={aOVG === "none" ? "block" : "display-none"}>
                <CapsuleButton 
                    text = {contributionStatus["assetOutsideVG"] === null
                    ? "Select"
                    : "View and Edit"}
                    padding = {contributionStatus["assetOutsideVG"] === null
                    ? "5px 35px" : '7px 35px'}
                    height = {contributionStatus["assetOutsideVG"] === null
                    ? 'auto' : null}
                    onClick={index => {
                      this.showContent((index = 1));
                    }}
                    id="btnSeleViewEditAOVG"
                    whiteBackground = {true}
                   />
              </div>
              <div
                className={
                  contributionStatus["assetOutsideVG"] !== null &&
                  aOVG === "none"
                    ? "block"
                    : "display-none"
                }
              >
                <RemoveWrapper>
                  <Underlinelink id="anrRemoveAssetOutside" onClick={() => this.showPopUp(1)}>
                    Remove
                  </Underlinelink>
                </RemoveWrapper>
              </div>
            </ViewEditRemove>
            <div className={aOVG === "block" ? "block" : "display-none"}>
              <AssetHeldOutsideVanguard
                status={contributionStatus["assetOutsideVG"]}
                id={"contributionTypeAssetHeld"}
              />
            </div>
            <div className={aOVG === "block" ? "block" : "display-none"}>
              {contributionStatus["assetOutsideVG"] === null ? (
                <CapsuleButton
                  text= "Show Less"
                  whiteBackground={true}
                  onClick={index => {
                    this.showContent((index = 1));
                  }}
                  id="btnShowLessAVG"
                />
              ) : (
                <ViewEditRemove>
                  <SaveAndContinueButton
                    primary
                    width="170px"
                    height="30px"
                    onClick={index => {
                      this.showContent((index = 1));
                    }}
                    id="btnSaveContAVG"
                  >
                    Save to continue
                  </SaveAndContinueButton>
                  <RemoveWrapper>
                    <Underlinelink id="anrClearAVG" onClick={() => this.showClearAllPopUp(1)}>
                      Clear All
                    </Underlinelink>
                  </RemoveWrapper>
                </ViewEditRemove>
              )}
            </div>
          </ContentWrapper>
        </AccordionBorder>
        <AccordionBorder id="checkAccId">
          <ContentWrapper id="checkid">
            <SubTitle>{config[2].Name}</SubTitle>
            {contributionStatus["checkOrEBT"] === null ? (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[2].Description)}
                ></div>
              </Content>
            ) : check === "none" ? (
              <ContentMessage justify="space-between" align="center">
                <Content>
                  <div
                    dangerouslySetInnerHTML={this.markup(config[2].Description)}
                  ></div>
                </Content>
                <ContentMessage marginBottom="10px" align="flex-start" mbFlexDirection="unset">
                  <CompleteIcon
                    status={contributionStatus["checkOrEBT"]}
                    src={
                      contributionStatus["checkOrEBT"] === true
                        ? completeTick
                        : contributionStatus["checkOrEBT"] === false
                        ? (this.state.isNextClicked ? incompleteError : inCompleteTick)
                        : null
                    }
                    alt={contributionStatus["checkOrEBT"] ? 'complete' : 'inComplete'}
                  />
                  <CompleteMessage status={contributionStatus["checkOrEBT"]} className={this.state.isNextClicked ? 'error' : ''}>
                    { contributionStatus["checkOrEBT"] === false
                      ? "Incomplete"
                      : null}
                  </CompleteMessage>
                </ContentMessage>
              </ContentMessage>
            ) : (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[2].Description)}
                ></div>
              </Content>
            )}
            <ViewEditRemove>
              <div className={check === "none" ? "block" : "display-none"}>
                <CapsuleButton 
                    text = {contributionStatus["checkOrEBT"] === null
                    ? "Select"
                    : "View and Edit"}
                    padding = {contributionStatus["checkOrEBT"] === null
                    ? "5px 35px" : '7px 35px'}
                    height = {contributionStatus["checkOrEBT"] === null
                    ? 'auto' : null}
                    onClick={index => {
                      this.showContent((index = 2));
                    }}
                    id="btnSelectViewEditCheck"
                    whiteBackground = {true}
                   />
              </div>
              <div
                className={
                  (contributionStatus["checkOrEBT"] !== null) &
                  (check === "none")
                    ? "block"
                    : "display-none"
                }
              >
                <RemoveWrapper>
                  <Underlinelink id="anrRemoveCheck" onClick={() => this.showPopUp(2)}>
                    Remove
                  </Underlinelink>
                </RemoveWrapper>
              </div>
            </ViewEditRemove>
            <div className={check === "block" ? "block" : "display-none"}>
              <CheckorEBT status={contributionStatus["checkOrEBT"]} isBlock={check} />
            </div>
            <div className={check === "block" ? "block" : "display-none"}>
              {contributionStatus["checkOrEBT"] === null ? (
                <CapsuleButton
                  text= "Show Less"
                  whiteBackground={true}
                  onClick={index => {
                    this.showContent((index = 2));
                  }}
                  id="btnCheckShowLess"
                />
              ) : (
                <ViewEditRemove>
                  <SaveAndContinueButton
                    className="ml0"
                    primary
                    width="170px"
                    height="30px"
                    onClick={index => {
                      this.showContent((index = 2));
                    }}
                    id="btnCheckSave"
                  >
                    Save to continue
                  </SaveAndContinueButton>
                  <RemoveWrapper>
                    <Underlinelink id="anrCheckClear" onClick={() => this.showClearAllPopUp(2)}>
                      Clear All
                    </Underlinelink>
                  </RemoveWrapper>
                </ViewEditRemove>
              )}
            </div>
          </ContentWrapper>
        </AccordionBorder>
        <AccordionBorder id="wireAccId">
          <ContentWrapper id="wireid">
            <SubTitle>{config[3].Name}</SubTitle>
            {contributionStatus["wire"] === null ? (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[3].Description)}
                ></div>
                
              </Content>
            ) : wire === "none" ? (
              <ContentMessage justify="space-between" align="center">
                <Content>
                  <div
                    dangerouslySetInnerHTML={this.markup(config[3].Description)}
                  ></div>
                 
                </Content>
                <ContentMessage marginBottom="10px" align="flex-start" mbFlexDirection="unset">
                  <CompleteIcon
                    status={contributionStatus["wire"]}
                    src={
                      contributionStatus["wire"] === true
                        ? completeTick
                        : contributionStatus["wire"] === false
                        ? (this.state.isNextClicked ? incompleteError : inCompleteTick)
                        : null
                    }
                    alt={contributionStatus["wire"] ? 'complete' : 'inComplete'}
                  />
                  <CompleteMessage status={contributionStatus["wire"]} className={this.state.isNextClicked ? 'error' : ''}>
                    {contributionStatus["wire"] === false
                      ? "Incomplete"
                      : null}
                  </CompleteMessage>
                </ContentMessage>
              </ContentMessage>
            ) : (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[3].Description)}
                ></div>
                
              </Content>
            )}
            <ViewEditRemove>
              <div className={wire === "none" ? "block" : "display-none"}>
                <CapsuleButton 
                    text = {contributionStatus["wire"] === null
                    ? "Select"
                    : "View and Edit"}
                    padding = {contributionStatus["wire"] === null
                    ? "5px 35px" : '7px 35px'}
                    height = {contributionStatus["wire"] === null
                    ? 'auto' : null}
                    onClick={index => {
                      this.showContent((index = 3));
                    }}
                    id="btnSelectWire"
                    whiteBackground = {true}
                   />
              </div>
              <div
                className={
                  (contributionStatus["wire"] !== null) & (wire === "none")
                    ? "block"
                    : "display-none"
                }
              >
                <RemoveWrapper>
                  <Underlinelink id="anrRemoveWire" onClick={() => this.showPopUp(3)}>
                    Remove
                  </Underlinelink>
                </RemoveWrapper>
              </div>
            </ViewEditRemove>
            <div className={wire === "block" ? "block" : "display-none"}>
              <Wire status={contributionStatus["wire"]} isBlock={wire} />
            </div>
            <div className={wire === "block" ? "block" : "display-none"}>
              {contributionStatus["wire"] === null ? (
                <CapsuleButton
                  text= "Show Less"
                  whiteBackground={true}
                  onClick={index => {
                    this.showContent((index = 3));
                  }}
                  id="btnShowLessWire"
                />
              ) : (
                <ViewEditRemove>
                  <SaveAndContinueButton
                    className="ml0"
                    primary
                    width="170px"
                    height="30px"
                    onClick={index => {
                      this.showContent((index = 3));
                    }}
                    id="btnSaveWire"
                  >
                    Save to continue
                  </SaveAndContinueButton>
                  <RemoveWrapper>
                    <Underlinelink id="anrClearWire" onClick={() => this.showClearAllPopUp(3)}>
                      Clear All
                    </Underlinelink>
                  </RemoveWrapper>
                </ViewEditRemove>
              )}
            </div>
          </ContentWrapper>
        </AccordionBorder>
        <AccordionBorder id="stockAccId">
          <ContentWrapper id="stockCertid">
            <SubTitle>{config[4].Name}</SubTitle>
            {contributionStatus["stockCertificate"] === null ? (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[4].Description)}
                ></div>
                
              </Content>
            ) : stock === "none" ? (
              <ContentMessage justify="space-between" align="center">
                <Content>
                  <div
                    dangerouslySetInnerHTML={this.markup(config[4].Description)}
                  ></div>
                 
                </Content>
                <ContentMessage marginBottom="10px" align="flex-start" mbFlexDirection="unset">
                  <CompleteIcon
                    status={contributionStatus["stockCertificate"]}
                    src={
                      contributionStatus["stockCertificate"] === true
                        ? completeTick
                        : contributionStatus["stockCertificate"] === false
                        ? (this.state.isNextClicked ? incompleteError : inCompleteTick)
                        : null
                    }
                    alt={contributionStatus["stockCertificate"] ? 'complete' : 'inComplete'}
                  />
                  <CompleteMessage  status={contributionStatus["stockCertificate"]} className={this.state.isNextClicked ? 'error' : ''}>
                    { contributionStatus["stockCertificate"] === false
                      ? "Incomplete"
                      : null}
                  </CompleteMessage>
                </ContentMessage>
              </ContentMessage>
            ) : (
              <Content>
                <div
                  dangerouslySetInnerHTML={this.markup(config[4].Description)}
                ></div>
                
              </Content>
            )}
            <ViewEditRemove>
              <div className={stock == "none" ? "block" : "display-none"}>
                <CapsuleButton 
                    text = {contributionStatus["stockCertificate"] === null
                    ? "Select"
                    : "View and Edit"}
                    padding = {contributionStatus["stockCertificate"] === null
                    ? "5px 35px" : '7px 35px'}
                    height = {contributionStatus["stockCertificate"] === null
                    ? 'auto' : null}
                    onClick={index => {
                      this.showContent((index = 4));
                    }}
                    id="btnSelectStock"
                    whiteBackground = {true}
                   />
              </div>
              <div
                className={
                  (contributionStatus["stockCertificate"] !== null) &
                  (stock === "none")
                    ? "block"
                    : "display-none"
                }
              >
                <RemoveWrapper>
                  <Underlinelink id="anrRemoveStock" onClick={() => this.showPopUp(4)}>
                    Remove
                  </Underlinelink>
                </RemoveWrapper>
              </div>
            </ViewEditRemove>
            <div className={stock === "block" ? "block" : "display-none"}>
              <StockCertificate
                status={contributionStatus["stockCertificate"]} isBlock={stock}
              />
            </div>
            <div className={stock === "block" ? "block" : "display-none"}>
              {contributionStatus["stockCertificate"] === null ? (
                <CapsuleButton
                  text= "Show Less"
                  whiteBackground={true}
                  onClick={index => {
                    this.showContent((index = 4));
                  }}
                  id="btnShowLessStock"
                />
              ) : (
                <ViewEditRemove>
                  <SaveAndContinueButton
                    className="ml0"
                    primary
                    width="170px"
                    height="30px"
                    onClick={index => {
                      this.showContent((index = 4));
                    }}
                    id="btnSaveStock"
                  >
                    Save to continue
                  </SaveAndContinueButton>
                  <RemoveWrapper>
                    <Underlinelink id="anrClearStock" onClick={() => this.showClearAllPopUp(4)}>
                      Clear All
                    </Underlinelink>
                  </RemoveWrapper>
                </ViewEditRemove>
              )}
            </div>
          </ContentWrapper>
        </AccordionBorder>
      </CollapseWrap>
    );
  };

  regexTest = (property ,value) => {
    return Rules[property] ? Rules[property].regex.test(value) : value.length;
  }

  validateFundInfo = (data, type, contribType) => {
    if (data !== undefined) {
      const fundInformation = data;
      const fundCount = data.length;
      for (let i = 0; i < fundCount; i++) {
        let fundInfo = fundInformation[i];
        if (contribType === "assetOutsideVG") {
          if (type === "mutualFund") {
            if (!(this.regexTest('tickerSymbol',fundInfo.tickerSymbol) &&
                 this.regexTest('fundName',fundInfo.fundName) &&
                (this.regexTest('numberofSharesAssetHeldOutsideVG',fundInfo.numberofShares) || fundInfo.allShare)
              )) { return false; }
          } else {
            if (
              !(
                this.regexTest('tickerSymbol',fundInfo.tickerSymbol) &&
                this.regexTest('securityName',fundInfo.securityName) &&
                (this.regexTest('numberofSharesAssetHeldOutsideVG',fundInfo.numberofShares) || fundInfo.allShare)
              )
            ) {
              return false;
            }
          }
        } else if (contribType === "assetHeldatVG") {
          if (type === "mutualFund") {
            if (
              !(
                (this.regexTest('tickerSymbol',fundInfo.tickerSymbol)) &&
                (this.regexTest('fundName',fundInfo.fundName)) &&
                (this.regexTest('fundNumber',fundInfo.fundNumber)) &&
                (this.regexTest('numberofShares',fundInfo.numberofShares) || fundInfo.allShare)
              )
            ) {
              return false;
            }
          } else {
            if (
              !(
                (this.regexTest('tickerSymbol',fundInfo.tickerSymbol)) &&
                (this.regexTest('securityName',fundInfo.securityName)) &&
                (this.regexTest('numberofShares',fundInfo.numberofShares) || fundInfo.allShare)
              )
            ) {
              return false;
            }
          }
        } else {
          if (type === "mutualFund") {
            if (
              !(
                (this.regexTest('tickerSymbol',fundInfo.tickerSymbol)) &&
                (this.regexTest('fundName',fundInfo.fundName)) &&
                (this.regexTest('fundNumber',fundInfo.fundNumber)) &&
                (this.regexTest('numberofShares',fundInfo.numberofShares) || fundInfo.allShare)
              )
            ) {
              return false;
            }
          } else {
            if (
              !(
                (this.regexTest('tickerSymbol',fundInfo.tickerSymbol)) &&
                (this.regexTest('securityName',fundInfo.securityName)) &&
                (this.regexTest('numberofShares',fundInfo.numberofShares) || fundInfo.allShare)
              )
            ) {
              return false;
            }
          }
        }
      }
    }
    return true;
  };

  validateAddress = (addresses, type, contribType, fund) => {
    let address = addresses[1];
    if(["Individual","Joint"].includes(type)&& (address.addressType === "Select one" || !address.addressType.length))
    {
     return false
    }
      if (!(
          (this.regexTest('line1',address.Address.line1)) &&
          (this.regexTest('line2',address.Address.line2)) &&
          (this.regexTest('line3',address.Address.line3)) &&
          (this.regexTest('city',address.Address.city)) &&
          (address.Address.country.length > 0)
        )) {
        return false;
      }
      if (address.Address.country === "United States") {
        if (!(Rules['zipCode']['regexUS'].test(address.Address.zipCode) && address.Address.state.length)) {
            return false;
        }
      } else {
        if (!(Rules['zipCode']['regexNonUS'].test(address.Address.zipCode) && this.regexTest('state',address.Address.state))) {
          return false;
        }
      }
      if (type === "Joint") {
        if (!(this.regexTest('firstName', address.firstName) && this.regexTest('lastName',address.lastName)))
          return false;
      } else if (!this.regexTest('name',address.name)) {
          return false;
      }
      if (contribType === "assetHeldatVG" || contribType === "assetOutsideVG") {
     if (address.relationToDonor.length > 0) {
          if (contribType === "assetHeldatVG" && fund === "mutualFund") {
            if (!this.regexTest('taxIdNumber',address.taxIdNumber)){
              return false;
            }
          }
        } else {
          return false;
        }
      }
      else if(type != "Other donor-advised fund")
      {
        return !!address.relationToDonor.length
      }
   
    return true;
  };

  validateBasicInfo = (data, fundType) => {
    if (fundType === "assetHeldatVG") {
      if (this.regexTest('donorType',data.type) && this.regexTest('VGAccountNumber', data.VGAccountNumber)) {
        return true;
      } else {
        return false;
      }
    } else if(fundType === "assetOutsideVG") {
      if(this.regexTest('donorType',data.type) && this.regexTest('holdingFirm',data.holdingFirm)) {
        return true;
      } else {
        return false;
      }
    } else {
      if(this.regexTest('donorType',data.type)) {
        return true;
      } else {
        return false;
      }
    }
  };

  enableNextButton = (value) => {
    contributionStatus = {        
      assetHeldatVG: null,
     assetOutsideVG: null,
     checkOrEBT: null,
     wire: null,
     stockCertificate: null };
    let data = {};
    let isOneSelected = "-1";
    let isButtonEnabled = true;
    data = this.props.contributionDetails;
    for (let contribType in data) {
      if (!(contribType === "dummyUpdate" || contribType === "isZipCodeAPI")) {
        if (
          contribType === "assetHeldatVG" ||
          contribType === "assetOutsideVG"
        ) {
          let contribData = data[contribType];
          //Mutual Fund
          if (contribData.mfSelected === true) {
            isOneSelected = true;
            let mutualFundInfo = contribData.mutualFund;
            for (let i = 0; i < mutualFundInfo.length; i++) {
              let mutualFund = mutualFundInfo[i];
              if(!(i > 0 && contributionStatus[contribType] === false)){
              if (this.validateBasicInfo(mutualFund, contribType)) {
                if (this.validateFundInfo(mutualFund.fundInformation,"mutualFund", contribType)) {
                  let isAddressValid = false;
                  if (mutualFund.type === "Individual") {
                    isAddressValid = true;
                  } else {
                    isAddressValid = this.validateAddress(
                      mutualFund.Donors,
                      mutualFund.type,
                      contribType,
                      "mutualFund"
                    );
                  }
                  if (isAddressValid) {
                      contributionStatus[contribType] = true;
                      isButtonEnabled = true;
                  } else {
                    contributionStatus[contribType] = false;
                    isButtonEnabled = false;
                  }
                } else {
                  contributionStatus[contribType] = false;
                  isButtonEnabled = false;
                }
              } else {
                contributionStatus[contribType] = false;
                isButtonEnabled = false;
              }
            }
            }
            if (contributionStatus[contribType] === null) {
              contributionStatus[contribType] = false;
            }
          } else {
            if (isOneSelected === "-1") {
              isOneSelected = false;
            }
            if (contributionStatus[contribType] === false) {
              contributionStatus[contribType] = null;
            }
          }
          //Security Gift
          if (contribData.sgSelected === true) {
            isOneSelected = true;
            let securityGiftInfo = contribData.securityGift;
            for (let i = 0; i < securityGiftInfo.length; i++) {
              let securityGift = securityGiftInfo[i];
              if(!(i > 0 && contributionStatus[contribType] === false && contributionStatus[contribType] === true)){
              if (this.validateBasicInfo(securityGift, contribType)) {
                if (
                  this.validateFundInfo(
                    securityGift.fundInformation,
                    "securityGift",
                    contribType
                  )
                ) {
                  let isAddressValid = false;
                  if (securityGift.type === "Individual") {
                    isAddressValid = true;
                  } else {
                    isAddressValid = this.validateAddress(
                      securityGift.Donors,
                      securityGift.type,
                      contribType,
                      "securityGift"
                    );
                  }
                  if (isAddressValid) {
                      if(contributionStatus[contribType] !== false){
                      contributionStatus[contribType] = true;
                      isButtonEnabled = true;
                      }
                  } else {
                    contributionStatus[contribType] = false;
                    isButtonEnabled = false;
                  }
                } else {
                  contributionStatus[contribType] = false;
                  isButtonEnabled = false;
                }
              } else {
                contributionStatus[contribType] = false;
                isButtonEnabled = false;
              }
            }
            }
            if (contributionStatus[contribType] === null) {
              contributionStatus[contribType] = false;
            }
          } else {
            if (isOneSelected === "-1") {
              isOneSelected = false;
            }
            if (contribData.mfSelected === false) {
              contributionStatus[contribType] = null;
            }
          }
        } else if (
          data["checkOrEBT"].checkSelected === true ||
          data["wire"].wireSelected === true ||
          data["stockCertificate"].stockSelected === true
        ) {
          if (
            contribType === "checkOrEBT" ||
            contribType === "wire" ||
            contribType === "stockCertificate"
          ) {
            let contribData = data[contribType];
            let fundInfo = {};
            //Check
            if (contribType === "checkOrEBT") {
              if (contribData.checkSelected === true) {
                fundInfo = contribData.checkEBTList;
                contributionStatus[contribType] = false;
                isOneSelected = true;
              } else {
                contributionStatus[contribType] = null;
              }
            } else if (contribType === "wire") {
              if (contribData.wireSelected === true) {
                fundInfo = contribData.wireList;
                contributionStatus[contribType] = false;
                isOneSelected = true;
              } else {
                contributionStatus[contribType] = null;
              }
            } else {
              if (contribData.stockSelected === true) {
                fundInfo = contribData.stockCertificateList;
                contributionStatus[contribType] = false;
                isOneSelected = true;
              } else {
                contributionStatus[contribType] = null;
              }
            }
            for (let i = 0; i < fundInfo.length; i++) {
              let securityGift = fundInfo[i];
              if(!(i > 0 && contributionStatus[contribType] === false)){
              if (this.validateBasicInfo(securityGift, contribType)) {
                if (
                  this.validateFundInfo(securityGift.fundInformation, "stock")
                ) {
                  let isAddressValid = false;
                  if (securityGift.type === "Individual") {
                    isAddressValid = true;
                  } else {
                    isAddressValid = this.validateAddress(
                      securityGift.Donors,
                      securityGift.type,
                      contribType,
                      "securityGift"
                    );
                  }
                  if (isAddressValid) {
                    if (
                      contribType === "checkOrEBT" ||
                      contribType === "wire"
                    ) {
                      if (
                        securityGift.Donors[1].addressType ===
                        "Other donor-advised fund"
                      ) {
                        if (securityGift.Donors[1].donorAdvisedFundName) {
                          if (!( this.regexTest('name',securityGift.Donors[1].donorAdvisedFundName))) {
                            contributionStatus[contribType] = false;
                            isButtonEnabled = false;
                          }
                        }
                      }
                        if (replaceNonDigit(securityGift.amount).replace(/,/g, '') > 0) {
                            contributionStatus[contribType] = true;
                            isButtonEnabled = true;
                        } else{
                           contributionStatus[contribType] = false;
                           isButtonEnabled = false;
                        }
                    } else {
                        contributionStatus[contribType] = true;
                        isButtonEnabled = true;
                    }
                  } else {
                    contributionStatus[contribType] = false;
                    isButtonEnabled = false;
                  }
                } else {
                  contributionStatus[contribType] = false;
                  isButtonEnabled = false;
                }
              } else {
                contributionStatus[contribType] = false;
                isButtonEnabled = false;
              }
            }
            }
          } else {
            if (isOneSelected === "-1") {
              isOneSelected = false;
            }
          }
        } else {
          contributionStatus[contribType] = null;
        }

        if (isOneSelected === false || isOneSelected === "-1") {
          contributionStatus[contribType] = null;
        }
      }
    }
    let currentStatus = JSON.parse(JSON.stringify(contributionStatus))
    if(value) contributionStatus[value] = null;
    let isAsset =
      contributionStatus["assetHeldatVG"] === null
        ? true
        : contributionStatus["assetHeldatVG"];
    let isAssetOut =
      contributionStatus["assetOutsideVG"] === null
        ? true
        : contributionStatus["assetOutsideVG"];
    let isCheck =
      contributionStatus["checkOrEBT"] === null
        ? true
        : contributionStatus["checkOrEBT"];
    let isWire =
      contributionStatus["wire"] === null ? true : contributionStatus["wire"];
    let isStock =
      contributionStatus["stockCertificate"] === null
        ? true
        : contributionStatus["stockCertificate"];
    isNextEnabled = isAsset && isAssetOut && isCheck && isWire && isStock;

    if(!(history.location.state && history.location.state.advisorType === "step1Edit")){
      if(value) currentStatus[value] = null;
      this.props.updateContributionStatusJson(currentStatus);
    }
    if (isOneSelected) {
      return isNextEnabled;
    } else {
      return false;
    }
  };

  hideAccordionBorder = () => {
    this.changeAccordionBorder('assetHeldAtVGAccId', 0);
    this.changeAccordionBorder('assetOutVGAccId', 0);
    this.changeAccordionBorder('checkAccId', 0);
    this.changeAccordionBorder('wireAccId', 0);
    this.changeAccordionBorder('stockAccId', 0);
    aOVG = 'none';
    check = 'none';
    wire = 'none';
    stock = 'none';
  }

  handleNext = () => {
    try {
      const enabled = this.enableNextButton();
      const data = this.props.contributionDetails;
      if (enabled) {
        this.hideAccordionBorder();
        if(data.assetHeldatVG.accessSelected){
          aVG = 'block';
          const elmnt = document.getElementById('assetHeldAccessId');
          elmnt.nextElementSibling.style.borderColor = 'red';
          this.scrollPage("assetHeldAtVGAccId");
        } else {
          const isSoftWarning = this.showAmountLimitationPopup(data);
          if (isSoftWarning) {
            softWarningPopUp = true;
            this.setState({ show: false });
          } else {
            const showTicker = this.showIncorrectTicker(data);
            if(showTicker) {
              softWarningPopUp = true;
              tickerWarningPopUp = true;
              this.setState({ show: false });
            } else {
              history.push("/contributions/make-a-contribution/investment-allocation");
              window.scrollTo(0, 0);      
            }    
          }
        }
      } else {
        this.showErrorOnNextClick(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  showAmountLimitationPopup = (data) => {
        let isSoftWarning = false;
        let minContributionAmount = 25000;
        if(this.props.isInitialContribution){
          minContributionAmount = 25000;
        }else{
          minContributionAmount = 5000;
        }
        if (data.checkOrEBT.checkSelected) {
          let checkList = data.checkOrEBT.checkEBTList;
          for (let i = 0; i < checkList.length; i++) {
            if (checkList[i].amount && checkList[i].amount !== "") {
              if (
                replaceNonDigit(checkList[i].amount).replace(/,/g, "") < minContributionAmount
              ) {
                isSoftWarning = true;
                break;
              }
            }
          }
        }
        if (!isSoftWarning) {
          if (data.wire.wireSelected) {
            let wireList = data.wire.wireList;
            for (let i = 0; i < wireList.length; i++) {
              if (wireList[i].amount && wireList[i].amount !== "") {
                if (
                  replaceNonDigit(wireList[i].amount).replace(/,/g, "") < minContributionAmount
                ) {
                  isSoftWarning = true;
                  break;
                }
              }
            }
          }
        }
  return isSoftWarning;
}

  showIncorrectTicker = (data) => {
    const fundData= this.props.fundDetails;
    let isIncorrectTicker = false;
    const assetHeldatVG = data.assetHeldatVG;
    if(assetHeldatVG.mfSelected){
      const accountMFCount = assetHeldatVG.mutualFund.length;
      for(let i=0; i < accountMFCount; i++){
        const currentAccountMF = assetHeldatVG.mutualFund[i].fundInformation;
        const fundCount = currentAccountMF.length;
        for(let j=0; j< fundCount; j++){
          const currentFund = currentAccountMF[j];
          let filterFund = [];
          filterFund = fundData.filter((fund) => fund.ticker.toLowerCase().trim() == currentFund.tickerSymbol.toLowerCase().trim());
          if(filterFund.length){
              for(let k=0; k<filterFund.length;k++){
                const filteredFund = filterFund[k];
                if(!(filteredFund.fundId.toString().toLowerCase().trim() == currentFund.fundNumber.toLowerCase().trim()
                  && filteredFund.fundName.toLowerCase().trim() == currentFund.fundName.toLowerCase().trim())){
                      isIncorrectTicker = true;
                      break;
                  }
                }
          }else {
            isIncorrectTicker = true;
            break;
          }
          if(isIncorrectTicker) break;
        }
        if(isIncorrectTicker) break;
      }
    }
    return isIncorrectTicker;
  }

  showErrorOnNextClick = (data) => {
    let isScrolled = false;
      aOVG = 'none';
      check = 'none';
      wire = 'none';
      stock = 'none';
      this.setState({update: !this.state.update});
      if(contributionStatus['assetHeldatVG'] !== null && contributionStatus['assetHeldatVG'] === false){
        isScrolled = true;
        this.changeAccordionBorder('assetHeldAtVGAccId', 1);
        this.scrollPage("assetHeldAtVGid", "assetHeldatVG");
      } else {
        this.changeAccordionBorder('assetHeldAtVGAccId', 0);
      }
      const elmnt = document.getElementById('assetHeldAccessId');
      if(data.assetHeldatVG.accessSelected){
        elmnt.nextElementSibling.style.borderColor = 'red';
        if(!isScrolled){
          aVG = 'block';
          this.scrollPage("assetHeldAtVGAccId");
          isScrolled = true;
        }else {
          aVG = 'none';
        }
      } else {
        aVG = 'none';
        elmnt.nextElementSibling.style.borderColor = '#b6bdbd';
      }

      if(contributionStatus['assetOutsideVG'] !== null && contributionStatus['assetOutsideVG'] === false){
        this.changeAccordionBorder('assetOutVGAccId', 1);
        if(!isScrolled){
          this.scrollPage("assetOutVGid", "assetOutsideVG");
          isScrolled = true;
        }
      } else {
        this.changeAccordionBorder('assetOutVGAccId', 0);
      }
      if(contributionStatus['checkOrEBT'] !== null && contributionStatus['checkOrEBT'] === false){
        this.changeAccordionBorder('checkAccId', 1);
        if(!isScrolled){
          this.scrollPage("checkid", "checkOrEBT");
          isScrolled = true;
        }
      } else {
        this.changeAccordionBorder('checkAccId', 0);
      }
      
      if(contributionStatus['wire'] !== null && contributionStatus['wire'] === false){
        this.changeAccordionBorder('wireAccId', 1);
        if(!isScrolled){
          this.scrollPage("wireid", "wire");
          isScrolled = true;
        }
      } else {
        this.changeAccordionBorder('wireAccId', 0);
      }

      if(contributionStatus['stockCertificate'] !== null && contributionStatus['stockCertificate'] === false){
        this.changeAccordionBorder('stockAccId', 1);
        if(!isScrolled){
          this.scrollPage("stockCertid", "stockCertificate");
          isScrolled = true;
        }
      } else {
        this.changeAccordionBorder('stockAccId', 0);
      }

      if(!isScrolled){
        this.scrollPage("selectOneType");
        this.setState({isOneSelected: false, isNextClicked: false});
      }else{
        this.setState({isOneSelected: true, isNextClicked : true});
      }
  }

  changeAccordionBorder = (id, active) => {
    const element = document.getElementById(id);
    if(element) element.style.borderColor = active ? 'red' : '#d4d4d4';
  }

  handleUpdate = (value) => {
    try {
      const updateEnabled = this.enableNextButton();    
      const data = this.props.contributionDetails;
      if(updateEnabled){
        this.hideAccordionBorder();
        if(data.assetHeldatVG.accessSelected){
            aVG = 'block';
            const elmnt = document.getElementById('assetHeldAccessId');
            elmnt.nextElementSibling.style.borderColor = 'red';
            this.setState({showError: false});
            this.scrollPage("assetHeldAtVGAccId");
        } else {
              const isSoftWarning = this.showAmountLimitationPopup(data);
              if (isSoftWarning) {
                softWarningPopUp = true;
                this.setState({
                  show: false
                });
              } else {
                const showTicker = this.showIncorrectTicker(data);
                if(showTicker) {
                  softWarningPopUp = true;
                  tickerWarningPopUp = true;
                  this.setState({ show: false });
                } else {
                  window.scrollTo(0, 0);
                  this.analyticsTracking(value);
                  history.push("/contributions/make-a-contribution/review");   
                }  
              }
              this.setState({isOneSelected: true, isNextClicked : true});
          }
      }
      else{
        this.showErrorOnNextClick(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  analyticsTracking = (value) => {
    initiateTracking(value.toLowerCase(),'Make a Contribution', 'Step 1 Select Contribution Type' ,value);
  }

  accordionAnalytics = (eventAction, accordionStatus, status) => {
    let buttonName = '';
    let action = '';
    if(status === null && accordionStatus === 'block'){
      buttonName = 'Select';
      action = 'select';
    } 
    if(status !== null){
      buttonName = accordionStatus === 'none' ? 'Save and Continue' : 'View and Edit';
      action = 'buttonStep';
    }
    if(buttonName){
        initiateTracking(action,'Make a Contribution', eventAction ,buttonName);
    }
  }

  removeAccordionAnalytics = (value) => {
    initiateTracking('remove','Make a Contribution', value ,'Remove');
  }

  warningContent = this.props.alertData && this.props.alertData.warning && this.props.alertData.warning.length ? 
  {
    heading: this.props.alertData.warning[0].field_header,
    line1: this.props.alertData.warning[0].field_description,
    line2: '',
    continue: this.props.alertData.warning[0].field_alert_button1_text,
    cancel: this.props.alertData.warning[0].field_alert_button2_text,
    type: "Info"
  } : {
    heading: "Contribution Amount",
    line1:
      "Minimum initial contribution is $25,000, and minimum additional contribution is $5,000.",
    line2: "Click Okay to Continue with your contribution or Cancel to edit your contribution",
    continue: "Okay",
    cancel: "Cancel",
    type: "Info"
  };

  cancelContent = this.props.alertData && this.props.alertData.cancel && this.props.alertData.cancel.length ? 
  {
    heading: this.props.alertData.cancel[0].field_header,
    line1: this.props.alertData.cancel[0].field_description,
    line2: '',
    continue: this.props.alertData.cancel[0].field_alert_button1_text,
    cancel: this.props.alertData.cancel[0].field_alert_button2_text,
    type: "Info"
  } : {
    heading: "Cancel changes",
    line1: "Any changes/updates made will be discarded.",
    line2: "Are you sure you want to continue?",
    continue: "continue",
    cancel: "No, take me back",
    type: "Info"
  };

  onContinueClick = () => {
    document.body.style.overflow = "";
    softWarningPopUp = false;
    this.setState({
      show: true
    });
    const data = this.props.contributionDetails;
    if(this.showIncorrectTicker(data)){
      softWarningPopUp = true;
      tickerWarningPopUp = true;
      this.setState({
        show: true
      });
    } else {
      if(history.location.state &&
        history.location.state.advisorType === "step1Edit"){
        history.push("/contributions/make-a-contribution/review");
      } else {
        history.push("/contributions/make-a-contribution/investment-allocation");
      }
      window.scrollTo(0, 0);
    }
  };

  onTickerContinueClick = () => {
    document.body.style.overflow = "";
    softWarningPopUp = false;
    tickerWarningPopUp = false;
    this.setState({
      show: true
    });
    if(history.location.state &&
      history.location.state.advisorType === "step1Edit"){
      history.push("/contributions/make-a-contribution/review");
    } else {
      history.push("/contributions/make-a-contribution/investment-allocation");
    }
    window.scrollTo(0, 0);
  };

  cancelConfirm = () => {
    document.body.style.overflow = "";
    softWarningPopUp = false;
    isCancelClicked = false;
    this.analyticsTracking('Cancel');
    this.props.step1Edit({ step: 1, edit: false });
    this.setState({
      show: true
    });
    window.scrollTo(0, 0);
    history.push("/contributions/make-a-contribution/review");
  };

  onCancelClick = () => {
    try {
      softWarningPopUp = true;
      isCancelClicked = true;
      this.setState({
        show: true
      });
    } catch (error) {
      recordError(error);
    }
  };

  render() {
    let isShow = this.state.show;
    let isUpdateEnabled = this.props.isEdit && isNextEnabled && this.props.isEditClicked;
    return (
      <div>
        {softWarningPopUp ? (
          <Popup
            data-test='popup-elem'
            height="330px"
            width= {tickerWarningPopUp ? "580px" : "510px" }
            mwidth="88%"
            mheight="53%"
            content={isCancelClicked ? this.cancelContent : (tickerWarningPopUp ? this.tickerPopupContent : this.warningContent)}
            closeModal={tickerWarningPopUp ? this.closeTickerModal : this.closeModal}
            handleRemove={
              isCancelClicked
                ? () => this.cancelConfirm()
                : (tickerWarningPopUp ? () => this.onTickerContinueClick() : () => this.onContinueClick())
            }
          />
        ) : null}
        {this.props.pageDetails ? (
          <BasicInfo>
            <div
              dangerouslySetInnerHTML={this.markup(
                this.props.pageDetails.pageDescription
              )}
            ></div>
          </BasicInfo>
        ) : (
          <></>
        )}

        {this.props.pageDetails ? (
          <Title marginTop="44px">
            {this.props.pageDetails.pageContributionType}
          </Title>
        ) : (
          <></>
        )}

        <BasicInfo marginTop="15px" mt="5px" marginBottom="30px" id="selectOneType" className={this.state.isOneSelected? '' : 'error'}>
        <div dangerouslySetInnerHTML={this.markup(this.props.pageDetails ? this.props.pageDetails.contributionTypeDescription : '')}></div>
        </BasicInfo>
        {this.props.contributeTypeConfig && this.props.isAPICalled ? (
          this.createAccordionData(this.props.contributeTypeConfig)
        ) : (
          <Preloader />
        )}
        <ComponentDivider marginTop="50px" marginBottom="50px" mT="40px" mB="40px" />
        {history.location.state &&
        history.location.state.advisorType === "step1Edit" ? (
          <DisplayFlexSpaceMobile marginBottom='0'>
            <DisplayFlex>
              <GeneralButton 
              data-test='btn-cancel'
              id="btnStep1Cancel"
              text = "Cancel"
              width = "150px"
              mobWidth = "100%"
              styling= "left"
              type = "functional"
              inverted = {true}
              onClick={
                this.props.isEdit && this.props.isEditClicked
                  ? this.onCancelClick
                  : () => this.handleUpdate('Cancel')
              }
            />
            </DisplayFlex>
            <CapsuleButtonWrapper marginBottom="30px" mobMTop="15px">
            <GeneralButton 
              text = "UPDATE"
              data-test='btn-update'
              id="btnStep1Update"
              width = "150px"
              mobWidth = "100%"
              styling= "right"
              onClick={() => this.handleUpdate('Update')}
            />
            </CapsuleButtonWrapper>
          </DisplayFlexSpaceMobile>
        ) : (
            <GeneralButton 
              data-test='next-btn'
              text = "Next"
              id="btnStep1Next"
              width = "150px"
              mobWidth = "100%"
              styling= "right mb3"
              onClick={() => this.handleNext(isNextEnabled)}
            />
        )}
      </div>
    );
  }
}

ContributionType.propTypes = {
  contributionDetails: PropTypes.object,
  isEditClicked: PropTypes.bool,
  contributionStatus: PropTypes.object,
  contributeTypeConfig: PropTypes.object,
  alertData: PropTypes.object,
  pageDetails: PropTypes.object,
  fundDetails: PropTypes.array,
  isEdit: PropTypes.bool,
  isAPICalled: PropTypes.bool, 
  isInitialContribution: PropTypes.bool,
  InitializeData: PropTypes.func,
  removeContributionType: PropTypes.func,
  updateClearStatus: PropTypes.func,
  updateContributionStatusJson: PropTypes.func,
  step1Edit: PropTypes.func,
  showErrorMessages: PropTypes.func,
}

const mapStateToProps = state => ({
  ...contributionTypeState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  InitializeData: arr =>
    dispatch(
      initializeValues({
        mutualFundAV: arr,
        securityGiftAV: JSON.parse(JSON.stringify(defaultSecurityGiftAHAV)),
        mutualFundOV: JSON.parse(JSON.stringify(defaultMutualFundAHOV)),
        securityGiftOV: JSON.parse(JSON.stringify(defaultSecurityGiftAHOV)),
        check: JSON.parse(JSON.stringify(defaultCheck)),
        stock: JSON.parse(JSON.stringify(defaultStock)),
        allocation: JSON.parse(JSON.stringify(defaultAllocation))
      })
    ),
  removeContributionType: (index, type) =>
    dispatch(
      removeContributionType({
        index,
        type,
        mutualFundAV: JSON.parse(JSON.stringify(defaultMutualFundAHAV)),
        securityGiftAV: JSON.parse(JSON.stringify(defaultSecurityGiftAHAV)),
        mutualFundOV: JSON.parse(JSON.stringify(defaultMutualFundAHOV)),
        securityGiftOV: JSON.parse(JSON.stringify(defaultSecurityGiftAHOV)),
        check: JSON.parse(JSON.stringify(defaultCheck)),
        stock: JSON.parse(JSON.stringify(defaultStock)),
        allocation: JSON.parse(JSON.stringify(defaultAllocation))
      })
    ),
  updateClearStatus: (index, mf, sg) =>
    dispatch(updateClearStatus({ index, isMF: mf, isSG: sg })),
  updateContributionStatusJson: contributionStatus =>
    dispatch(
      updateContributionStatusJson({ contributionStatus: contributionStatus })
    ),
  step1Edit: data => dispatch(step1Edit(data)),
  showErrorMessages: data => dispatch(showErrorMessages(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContributionType)
);